<!-- パスワード確認コンポーネント -->
<template>
    <div class="regist">
        <slot name="note"></slot>
        <form method="post" ref="passwordForm" @submit.prevent="submit">
            <input :value="dataCsrf"
                   :name="dataCsrfName"
                   type="hidden">
            <slot name="errors"></slot>
            <dl class="formContainer">
                <dt>パスワード</dt>
                <dd>
                    <template v-if="$v.password.$error">
                    <span v-if="!$v.password.required"
                          class="errNote">パスワードを入力してください。</span>
                    </template>
                    <div class="pswdShowHide">
                        <input v-model="$v.password.$model"
                               :type="inputType"
                               name="password"
                               placeholder="パスワード"
                               class="regular">
                        <i @click="toggle"
                           @keydown.enter="toggle"
                           :class="iconClass"  tabIndex="0" aria-label="パスワード表示/非表示">パスワード表示/非表示</i>
                    </div>
                    <span class="formNote">
                    <slot name="recovery-note"></slot>
                </span>
                </dd>
            </dl>
            <div class="btnSpace">
                <button :disabled="isDisabled"
                        type="submit">ログイン</button>
            </div>
        </form>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mixinJleague, EnumEditPage } from '../mixin/utility'

Vue.use(Vuelidate)

export default {
    name: 'PasswordConfirm',
    mixins: [mixinJleague],
    data: function(){
        return {
            password: '',
            isShowPassword: false
        }
    },
    validations: {
        password: {
            required
        }
    },
    props: {
        dataCsrf: {
            type: String,
            required: true
        },
        dataCsrfName: {
            type: String,
            required: true
        },
        params: {
            type: Object,
            default: function(){
                return {};
            }
        }
    },
    computed: {
        iconClass: function(){
            const klass = this.isShowPassword? 'show': '';
            return ['pwSwitch', klass];
        },
        inputType: function(){
            return this.isShowPassword? 'text': 'password';
        },
        isDisabled: function(){
            return this.$v.$invalid;
        },
        action: function(){
            const params = Object.assign({}, this.params);
            let _url = location.href;

            if (params.edit) {
                if (params.edit === EnumEditPage.EmailSetting) {
                    if (!params.club_cd) delete params.club_cd;
                } else {
                    delete params.club_cd;
                }
                _url = this.addUrlParams(_url, params);
            }

            return _url;
        }
    },
    methods: {
        submit: function(){
            const form = this.$refs.passwordForm;
            // クエリストリングが必要な画面はフォームのactionの値を指定する
            if (this.params.edit) form.action = this.action;

            this.$v.$touch();
            if (this.$v.$invalid) {
                alert('バリデーションエラー');
                return false;
            } else {
                form.submit();
            }
        },
        toggle: function(){
            this.isShowPassword = !this.isShowPassword;
        }
    }
}
</script>
